import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/empleado/getEmpleado.php';

export default function getEmpleado({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}